import * as orderApi from '../../api/orderApi'

const state = {
	OrderReceiveInput: {
		OrderId: null,
		PayType: 88 
	},

	ImgCommentUrl: null,
	ImgUrl: null,

	Money: 0,
	OrderStatus: null,
	ServiceShopNo: null
}

const actions = {
	//判定跳转页面
	async orderReceive({
		commit
	}, param) {
		const response = await orderApi.OrderReceive(param);
		state.OrderReceiveInput.OrderId = param.SysNo;
		commit('setEndData',response);
		return response;
	},
	//获取订单状态
	async getOrderStatus({
		commit
	}, order) {
		const response = await orderApi.GetOrderDetail(order);
		commit('setOrderStatus', response);
		return response;
	},
	//获取支付数据
	async refreshQRCode({
		commit
	}, param) {
		const response = await orderApi.RefreshQRCode(param);
		state.OrderReceiveInput.OrderId = param.SysNo;
		commit('setImg', response);
		return response;
	},
	//获取评价数据
	async getCommentQRCode({
		commit
	}, param) {
		const response = await orderApi.GetCommentQRCode(param);
		state.OrderReceiveInput.OrderId = param.SysNo;
		commit('setImg', response);
		return response;
	}
}

const mutations = {
	//根据订单ID判定跳转支付
	setImg(state, res) {
		state.ImgCommentUrl = "";
		state.ImgUrl = "";
		if (res && res.Status) { // 成功
			state.ServiceShopNo = res.Data.ServiceShopNo;
			if (res.Data.OrderStatus === 100) //状态已完成
			{
				// state.ImgUrl = "";
				// state.ImgCommentUrl = 'data:image/png;base64,' + res.Data.ImgUrl;
				// state.Money = res.Data.Money;
			} else //状态待收款
			{
				if(state.OrderReceiveInput.PayType === 1010 || state.OrderReceiveInput.PayType === 88)
				{
					state.Money = res.Data.Money;
					state.ImgUrl = 'data:image/png;base64,' + res.Data.ImgUrl;
				}
			}
		}
	},
	setEndData(state, res)
	{
		if(res.Status === true){
		state.ServiceShopNo = res.Data.ServiceShopNo;
		state.Money = res.Data.Money;
		}
	},
	setOrderStatus(state, res) {
		if (res && res.Status) { // 成功
			state.OrderStatus = res.Data.OrderStatus;
		}
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/orderReceiveMoney.js